import GradientText from 'components/gradient-text/GradientText'
import classes from './styles.module.css'
import {extraFooterData} from 'content/footer'
import Image from 'next/image'
export default function Extra() {
  // extraFooterData
  return (
    <div className={classes.container}>
      <section className={classes.headerContainer}>
        <GradientText text={extraFooterData.topTitle} />
        <h2 className={classes.title}>{extraFooterData.title}</h2>
        <h3 className={classes.desc}> {extraFooterData.desc}</h3>
      </section>
      <section className={classes.firstCard}>
        <div className={classes.textContent}>
          <h4 className={classes.title2}> {extraFooterData.card.title}</h4>
          <p className={classes.desc2}>{extraFooterData.card.subTitle}</p>
        </div>
        <div className={classes.imageContainer}>
          <Image
            className={classes.firstCardImage}
            src={extraFooterData.card.img}
            alt="how its made "
          />
        </div>
      </section>
      <section className={classes.bottomCard}>
        {extraFooterData.bottomCard.map(data => (
          <div className={classes.bottomSingleCard} key={data.title}>
            <div className={classes.bottomCardImageContainer}>
              <Image className={classes.bottomCardImage} src={data.img} alt="best practice" />
            </div>
            <div className={classes.bottomCardTextContent}>
              <h4 className={classes.title3}>{data.title}</h4>
              <p className={classes.desc3}>{data.desc}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  )
}
